export const ui = {
  btnPrimary:
    "rounded-none bg-cyan-400 text-black font-mono font-bold uppercase tracking-wider border border-cyan-200 shadow-[0_0_18px_rgba(0,245,255,0.45)] hover:bg-cyan-300 hover:shadow-[0_0_28px_rgba(0,245,255,0.75)] transition-[background-color,box-shadow,transform] duration-200 active:scale-95",
  btnSecondary:
    "rounded-none bg-slate-950 text-cyan-300 font-mono font-bold uppercase tracking-wider border border-cyan-500/40 hover:border-cyan-300 hover:bg-cyan-950/40 hover:text-white transition-colors duration-200",
  btnMagenta:
    "rounded-none bg-[#FF007F] text-white font-mono font-bold uppercase tracking-wider border border-pink-300 shadow-[0_0_18px_rgba(255,0,127,0.45)] hover:bg-pink-500 hover:shadow-[0_0_28px_rgba(255,0,127,0.75)] transition-[background-color,box-shadow,transform] duration-200 active:scale-95",
  input:
    "rounded-none bg-slate-950/90 border-slate-700 text-slate-100 font-mono placeholder:text-slate-600 focus-visible:ring-1 focus-visible:ring-cyan-400 focus-visible:border-cyan-400 focus-visible:ring-offset-0",
  card: "bg-[#0A0F1C]/90 border border-slate-800 backdrop-blur-md relative",
  label: "font-mono text-[11px] uppercase tracking-[0.18em] text-cyan-400/80",
  menu: "rounded-none bg-[#060A14] border border-cyan-500/30 text-slate-100 font-mono",
};

export const STATUS_STYLES = {
  Requested: "text-[#FFE600] border-[#FFE600]/50 bg-[#FFE600]/10",
  Dispatched: "text-[#00F5FF] border-[#00F5FF]/50 bg-[#00F5FF]/10",
  Completed: "text-[#00FF66] border-[#00FF66]/50 bg-[#00FF66]/10",
  Cancelled: "text-[#FF2A2A] border-[#FF2A2A]/50 bg-[#FF2A2A]/10",
  Paid: "text-[#00FF66] border-[#00FF66]/50 bg-[#00FF66]/10",
  Pending: "text-[#FF6B00] border-[#FF6B00]/50 bg-[#FF6B00]/10",
  Unpaid: "text-[#FF2A2A] border-[#FF2A2A]/50 bg-[#FF2A2A]/10",
};

export const JOB_STATUSES = ["Requested", "Dispatched", "Completed", "Cancelled"];
export const PAYMENT_STATUSES = ["Paid", "Pending", "Unpaid"];
